import { createGlobalStyle } from 'styled-components';

const commonTypographyStyles = (props) => {
  return `
    font-family: ${props.theme.typography.fontFamily[props.fontFamily] || props.fontFamily || 'inherit'};
  `;
};
const textCommonStyles = (props) => {
  return `
    color: ${props.theme.colors.text[props.color] || props.color || props.theme.colors.text.primary};
    ${(props) => commonTypographyStyles(props)}
  `;
};
const headingCommonStyles = (props) => {
  return `
    display: flex;
    align-items: center;
    ${hiddenAnchorStyles()}
    color: ${props.theme.colors.heading[props.color] || props.color || props.theme.colors.heading.primary};
    ${(props) => commonTypographyStyles(props)}
  `;
};

const hiddenAnchorStyles = () => {
  return `
    scroll-margin-top: 100px;
  `;
}

const GlobalStyle = createGlobalStyle`
  *:not(deckgo-highlight-code),
  :after,
  :before {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: ${(props) => props.theme.typography.fontFamily};
    color:  ${(props) => props.theme.colors.text.primary};
    letter-spacing: ${(props) => props.theme.typography.letterSpacing};
    word-spacing: ${(props) => props.theme.typography.wordSpacing};
    font-size: ${(props) => props.theme.typography.baseFontSize.xs};
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: ${(props) => props.theme.colors.primary};
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    width: 100%;
    height: 100vh;

    table {
      border: 1px solid ${(props) => props.theme.colors.secondary};
      border-collapse: collapse;

      th {
        font-weight: 900;
        padding: 0;
      }

      tr, td {
        border: 1px solid ${(props) => props.theme.colors.secondary};
      }

      td {
        padding: 10px
      }

      tr:nth-child(even) {
        background: ${(props) => props.theme.colors.tertiary};
      }
    }
    blockquote {
      font-style: italic;
      opacity: 0.7;
      padding-left: 10px;
      margin: 20px;
      border-left: 4px solid ${(props) => props.theme.colors.secondary};
    }
  }

  .showOnMobileOnly {
      // Tablet
      @media only screen and (min-width: ${(props) => props.theme.screenSizeBreakpoints.xs}) {
        display: none !important;
      }
    }

  .hideOnMobile {
    // Tablet
    @media only screen and (max-width: ${(props) => props.theme.screenSizeBreakpoints.xs}) {
      display: none !important;
    }
  }

  .hideOnTablet {
    // Tablet
    @media only screen and (max-width: ${(props) => props.theme.screenSizeBreakpoints.s}) {
      display: none !important;
    }
  }
  
  // ------------
  // Articles
  // ------------

  article {
    .gatsby-resp-image-wrapper {
      margin: 0 !important;
      max-width: 100% !important;
    }
  }
  
  // Syntax highlighting

  .gatsby-highlight {
    background-color: #2D2D2D;
    border-radius: 0.5em;
    margin: 1em 0 0 0;
    padding: 0.8em 0.3em 0 0.3em !important;
    overflow: auto;
  }

  .gatsby-remark-prismjs-copy-button-container {
    left: -10px !important;
    top: 50px !important;
  }

  .gatsby-remark-prismjs-copy-button {
    box-sizing: border-box !important;
    border: 1px solid #414853;
    background-color: #414853 !important;
    padding: 0.3em 0.5em !important;
    line-height: normal;

    &:hover {
      background-color: #414853;
      border-color: #5C73E7;
      color: #DFDFD6;
    }
  }

  .gatsby-highlight {
    background-color: #383838;
  }

  [class*="language-"] {
    background-color: #383838 !important;
  }

  // Typography

  // Tablet
  @media only screen and (min-width: ${(props) => props.theme.screenSizeBreakpoints.xs}) {
    *:not(deckgo-highlight-code),
    :after,
    :before {
      font-size: ${(props) => props.theme.typography.baseFontSize.s}
    }
  }

  // small screen
  @media only screen and (min-width: ${(props) => props.theme.screenSizeBreakpoints.s}) {
    *:not(deckgo-highlight-code),
    :after,
    :before {
      font-size: ${(props) => props.theme.typography.baseFontSize.m}
    }
  }

  // medium screen
  @media only screen and (min-width: ${(props) => props.theme.screenSizeBreakpoints.m}) {
    *:not(deckgo-highlight-code),
    :after,
    :before {
      font-size: ${(props) => props.theme.typography.baseFontSize.l}
    }
  }

  // Big screen
  @media only screen and (min-width: ${(props) => props.theme.screenSizeBreakpoints.l}) {
    *:not(deckgo-highlight-code),
    :after,
    :before {
      font-size: ${(props) => props.theme.typography.baseFontSize.xl};
    }
  }

  h1 {
    font-size: calc(1em * ${(props) => Math.pow(props.theme.typography.scaleRatio, 4)});
    font-weight: ${(props) => props.theme.typography.fontWeight.h1};
    margin: ${(props) => props.theme.typography.marginTop.h1} 0 ${(props) => props.theme.typography.marginBottom.h1} 0;
    ${(props) => headingCommonStyles(props)}
  }
  h2{
    font-size: calc(1em * ${(props) => Math.pow(props.theme.typography.scaleRatio, 3)});
    font-weight: ${(props) => props.theme.typography.fontWeight.h2};
    margin: ${(props) => props.theme.typography.marginTop.h2} 0 ${(props) => props.theme.typography.marginBottom.h2} 0;
    ${(props) => headingCommonStyles(props)};
  }
  h3{
    position:relative;
    font-size: calc(1em * ${(props) => Math.pow(props.theme.typography.scaleRatio, 2)});
    font-weight: ${(props) => props.theme.typography.fontWeight.h3};
    margin: ${(props) => props.theme.typography.marginTop.h3} 0 ${(props) =>
  props.theme.typography.marginBottom.h3} 0;
    ${(props) => headingCommonStyles(props)};
  }
  h4{
    font-size: calc(1em * ${(props) => Math.pow(props.theme.typography.scaleRatio, 1)});
    font-weight: ${(props) => props.theme.typography.fontWeight.h4};
    margin: ${(props) => props.theme.typography.marginTop.h4} 0 ${(props) => props.theme.typography.marginBottom.h4} 0;
    ${(props) => headingCommonStyles(props)}
  }
  h5{
    font-size: calc(1em * ${(props) => Math.pow(props.theme.typography.scaleRatio, 0.75)});
    font-weight: ${(props) => props.theme.typography.fontWeight.h5};
    margin: ${(props) => props.theme.typography.marginTop.h5} 0 ${(props) => props.theme.typography.marginBottom.h5} 0;
    ${(props) => headingCommonStyles(props)}
  }
  h6{
    font-size: calc(1em * ${(props) => Math.pow(props.theme.typography.scaleRatio, 0.5)});
    font-weight: ${(props) => props.theme.typography.fontWeight.h6};
    margin: ${(props) => props.theme.typography.marginTop.h6} 0 ${(props) => props.theme.typography.marginBottom.h6} 0;
    ${(props) => headingCommonStyles(props)}
  }
  p{
    font-size: 1em;
    font-weight: ${(props) => props.theme.typography.fontWeight.p};
    line-height: 1.7em;
    margin: ${(props) => props.theme.typography.marginTop.p} 0 ${(props) => props.theme.typography.marginBottom.p} 0;
    ${(props) => textCommonStyles(props)};
  }
  
  main {
    a {
      color: ${(props) => props.theme.colors.text.emphasized};

      &:hover {
        color: white;
        text-decoration: none;
        background-color: ${(props) => props.theme.colors.text.emphasized};
      }
    }
  }

  // Autolink headers
  .hidden-anchor {
    ${hiddenAnchorStyles()}
  }

  .autolink-header-anchor-link {
    background-color: transparent;
    color: ${(props) => props.theme.colors.text.emphasized};
    display: inline-flex;
    align-items: center;
    top: unset !important;

    &:hover {
      color: ${(props) => props.theme.colors.text.primary};
      background-color: transparent;
    }

    svg {
      fill: ${(props) => props.theme.colors.text.emphasized};
    }
  }

  // Lists
  li{
    line-height: 2em;
  }
`;

export { GlobalStyle };
